import { useState } from "react";

export function BackupCcEditor({ emails, disabled, onSave }) {
  const [draft, setDraft] = useState("");
  const [err, setErr] = useState("");
  const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const add = () => {
    const v = draft.trim();
    if (!v) return;
    if (!EMAIL_RE.test(v)) { setErr("Geçersiz e-posta"); return; }
    if (emails.includes(v)) { setErr("Zaten eklenmiş"); return; }
    if (emails.length >= 3) { setErr("En fazla 3 adres"); return; }
    setErr("");
    onSave([...emails, v]);
    setDraft("");
  };
  const remove = (e) => onSave(emails.filter(x => x !== e));
  return (
    <div className="cc-editor" data-testid="backup-cc-editor">
      <div className="cc-chips">
        {emails.map((e) => (
          <span className="cc-chip" key={e} data-testid={`cc-chip-${e}`}>
            {e}
            <button type="button" onClick={() => remove(e)} disabled={disabled} data-testid={`cc-remove-${e}`} aria-label="Kaldır">×</button>
          </span>
        ))}
      </div>
      <div className="cc-add-row">
        <input
          type="email"
          placeholder="muhasebe@sirket.com"
          value={draft}
          onChange={(e) => { setDraft(e.target.value); setErr(""); }}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          disabled={disabled || emails.length >= 3}
          data-testid="cc-email-input"
        />
        <button type="button" className="outline-button" onClick={add} disabled={disabled || !draft.trim() || emails.length >= 3} data-testid="cc-add-button">Ekle</button>
      </div>
      {err && <small style={{ color: "#dc2626", fontSize: 11 }} data-testid="cc-error">{err}</small>}
    </div>
  );
}
